import React from 'react';
import styles from '../../../styles/ListingManagement.module.css';

const SkeletonLine: React.FC<{ width?: string; height?: number }> = ({ width = '100%', height = 16 }) => (
  <div className={styles.skeletonLine} style={{ width, height }} />
);

const SkeletonStatCard: React.FC = () => (
  <div className={styles.skeletonStatCard}>
    <SkeletonLine width="55%" height={32} />
    <SkeletonLine width="70%" height={11} />
  </div>
);

const SkeletonTableRow: React.FC = () => (
  <div className={styles.skeletonTableRow}>
    <SkeletonLine width="30%" height={14} />
    <SkeletonLine width="12%" height={14} />
    <SkeletonLine width="12%" height={14} />
    <SkeletonLine width="10%" height={14} />
    <SkeletonLine width="14%" height={22} />
    <SkeletonLine width="8%" height={14} />
    <SkeletonLine width="16%" height={14} />
  </div>
);

interface ListingManagementSkeletonProps {
  title: string;
  subtitle: string;
}

const ListingManagementSkeleton: React.FC<ListingManagementSkeletonProps> = ({ title, subtitle }) => (
  <div className={styles.listingManagementContainer}>
    <div className={styles.listingManagementContent}>
      <div className={styles.listingManagementHeader}>
        <h1 className={styles.listingManagementTitle}>{title}</h1>
        <p className={styles.listingManagementSubtitle}>{subtitle}</p>
      </div>

      {/* Stats card */}
      <div className={styles.listingManagementSection}>
        <div className={styles.skeletonStatCards}>
          {[0, 1, 2, 3].map((i) => <SkeletonStatCard key={i} />)}
        </div>
      </div>

      {/* Table card */}
      <div className={styles.listingManagementSection}>
        {/* Filter bar */}
        <div className={styles.skeletonFilterRow}>
          <SkeletonLine width="130px" height={34} />
          <SkeletonLine width="130px" height={34} />
          <SkeletonLine width="1px" height={34} />
          <SkeletonLine width="160px" height={34} />
          <SkeletonLine width="160px" height={34} />
        </div>
        {/* Table header */}
        <div className={styles.skeletonTableHeader}>
          {['30%', '12%', '12%', '10%', '14%', '8%', '16%'].map((w, i) => (
            <SkeletonLine key={i} width={w} height={13} />
          ))}
        </div>
        {/* Table rows */}
        {[0, 1, 2, 3, 4].map((i) => <SkeletonTableRow key={i} />)}
      </div>
    </div>
  </div>
);

export default ListingManagementSkeleton;
